module.exports = __webpack_public_path__ + "static/FiraCode-Regular-3233efd2c961c41df58098c75efdd17f.otf";